export enum ORDER_DATA {
    WHOLESALE_PRICE = "wholesale_price",
    RETAIL_PRICE = "retail_price",
    BULK_PRICES = "bulk_totals",
}

export enum PPS_DATA {
    WHOLESALE_PRICE = "cost_vendor_pps",
    RETAIL_PRICE = "retail_vendor_pps",
}

export enum LINE_ITEMS_SOURCE {
    BRAND_PORTAL = "brand_portal",
    MARKETPLACE = "marketplace",
    API = "api",
}

export const LINE_ITEMS_SOURCE_LABEL = {
    [LINE_ITEMS_SOURCE.BRAND_PORTAL]: "Brand Portal",
    [LINE_ITEMS_SOURCE.MARKETPLACE]: "Marketplace",
    [LINE_ITEMS_SOURCE.API]: "API",
};
